<section class="main_section">
  <div class="section_left_part w-100">
    
    <div (click)="closePopup()" class="d-flex align-items-center justify-content-end">
      <mat-icon class="d-flex align-items-center justify-content-end f-15 cursor">close</mat-icon>
    </div>
    <div class="continue-to text-center mb-2">
      Continue to Simpo
    </div>
    <div class="sub-text text-center">
      Sign in with Google or use your email and password.
    </div>
   
    <div *ngIf="formType === 'SIGN_UP'" class="signup_body">
      <form [formGroup]="signupForm">
        <div class="field">
          <div class="label">Name <sup>*</sup></div>
          <input class="input-container" formControlName="name" matInput placeholder="Enter Your  Name"/>
        </div>
        <div class="fields">
          <div class="field">
            <div class="label">Email <sup>*</sup></div>
            <input (input)="onEmailChange($event)" class="input-container" formControlName="email" matInput
                   placeholder="Enter your email"/>
          </div>
        </div>
        <div class="field">
          <div class="label">Mobile Number <sup>*</sup></div>
          <div class="code_number">
            
            <div class="mobile_number w-100">
              <input class="input-container" formControlName="mobileNumber" matInput onKeyPress="if(this.value.length==15) return false;"
                     placeholder="Enter Your Mobile Number" type="number"/>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="label">Password <sup>*</sup></div>
          <div class="password-container input-container d-flex justify-content-between align-items-center">
            <input (blur)="hide()" [type]="signupHide ? 'password' : 'text'" formControlName="password"
                   id="focus" matInput maxlength="16" minlength="8" placeholder="Enter Password"/>
            <mat-icon (click)="signupHide = !signupHide" class="eye-icon" matSuffix style="cursor:pointer">{{
                signupHide
                  ? 'visibility_off' : 'visibility'
              }}
            </mat-icon>
          </div>
          <div class="password_length">
            Password must have <span
            [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['minimumLength']}">at
              least 8 characters</span>, <span
            [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['oneLetterCapital']}">including
              1 uppercase letter</span>, <span
            [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['oneNumberPattern']}">1
              number</span>, and <span
            [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['oneSymbolPattern']}">1
              special character</span>
          </div>
        </div>
        <div class="term_conditions text-center">
          By creating an account, you agree to our <span (click)="termsConditions()" class="privacy">Terms</span> &
          <span (click)="privacyPolicy()" class="privacy">Privacy Policy</span>
        </div>
        <div class="continue_btn">
          <button (click)="createAnAccount()" *ngIf="!loader" [disabled]="!signupForm.valid"
                  [ngClass]="{'disable-btn': !signupForm.valid}">
            Create an account
          </button>
          <button *ngIf="loader">
            <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
          </button>
        </div>
      </form>
      <div class="alrea_account">
        Already have an account? <span (click)="redirectToSignIn()" class="privacy" style="cursor: pointer;">Sign
          In</span>
      </div>
    </div>
    <div *ngIf="formType === 'LOGIN'" class="signin_body">
      <form [formGroup]="signInForm">
        <div class="fields">
          <div class="field">
            <div class="label">Email Address <span class="clr-red">*</span></div>
            <input (input)="onEmailChange($event)" class="input-container" formControlName="email" matInput
                   placeholder="Enter Email Address"/>
          </div>
          <div class="field">
            <div class="label">Password<span class="clr-red">*</span></div>
            <div class="password-container input-container d-flex align-items-center justify-content-between">
              <input (keyup.enter)="login()" [type]="signinHide ? 'password' : 'text'" formControlName="password"
                     matInput placeholder="Enter Password"/>
              <mat-icon (click)="signinHide = !signinHide" class="eye-icon" matSuffix>{{
                  signinHide ? 'visibility_off' :
                    'visibility'
                }}
              </mat-icon>
            </div>
          </div>
          <div (click)="forgotPasword()" class="forgot-password">
            Forgot password
          </div>
          <div class="continue_btn">
            <button (click)="login()" *ngIf="!loader" [disabled]="!signInForm.valid"
                    [ngClass]="{'disable-btn': !signInForm.valid}">
              Login
            </button>
            <button *ngIf="loader">
              <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
            </button>
          </div>
        </div>
      </form>
      <div class="alrea_account" style="display: flex;justify-content: center;margin-top: 15px;">
     
        <div class="alrea_account">
          No account yet? <span (click)="redirectToSignup()" class="privacy" style="cursor: pointer;">Sign Up</span>
        </div>
      </div>
      <div class="continue-with">
        <hr>
        <div style="color: rgba(107,114,128,var(1));text-align: center;white-space: nowrap;">Or</div>
        <hr>
      </div>
      <div class="google-container d-flex align-items-center justify-content-center mt-2">
        <!-- <img src="https://prod-simpo.s3.ap-south-1.amazonaws.com/prod-images/839577c1743600998516image%2075.png" alt="google-icon">
        Sign in with Google -->
        <asl-google-signin-button GoogleSigninButtonDirective id="google_autenticate" shape='rectangular' size='large'
                                  type='standard'></asl-google-signin-button>
      </div>
    </div>
    
  </div>
</section>


<div class="delete-popup">
  <div aria-hidden="true" aria-labelledby="deletepopupLabel" class="modal" id="error" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered" style="z-index:1001;">
      <div class="modal-content">
        <div class="top-section-modal">
          <img alt class="delete-img" src="../../../../../../assets/images/invoice/delete-invoice.svg">
          <div class="error-text">
            User already exists with given details.
          </div>
        </div>
        <div class="button">
          <button (click)="closeWindow()" class="cancel-button" data-bs-dismiss="modal" type="button">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
